import React from 'react'
import { getContrastColor } from '../../helpers/helpers'
import { useCurrentTheme } from '../../hooks/useCurrentTheme'

export function TableLogoSvg() {
	const settings = useCurrentTheme()

	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 249.35 62.34' width={100} height={18} x='39%' y='66%'>
			<style>
				{` .tb0{opacity:0.1;fill:${getContrastColor(settings.trainer.table)};font-weight:bold;},
            .tb1{opacity:0.3;} .tb2{fill-rule:evenodd;clip-rule:evenodd;fill:#151720;opacity: 0.2;}
            .tb4{fill:rgb(57, 217, 138);opacity: 0.2;}.tb5{fill:rgb(91, 141, 239);opacity: 0.2;}.tb6{fill:rgb(255, 92, 92);opacity: 0.2;}`}
			</style>

			<g>
				<path
					className='tb0'
					d='M72.55,40.62c-2.71-2.71-4.06-6.13-4.06-10.26c0-4.17,1.39-7.59,4.21-10.3c2.82-2.75,6.24-4.1,10.3-4.1
		c4.62,0,8.95,1.96,11.47,4.92l-2.97,2.93c-2.22-2.44-5.04-3.65-8.46-3.65c-2.9,0-5.3,0.98-7.22,2.9c-1.92,1.92-2.9,4.36-2.9,7.29
		c0,2.9,0.94,5.34,2.86,7.26s4.29,2.86,7.14,2.86c3.2,0,6.35-1.39,8.46-3.61V31.9h-8.76v-3.91h12.78v10.9
		c-3.46,3.83-7.67,5.75-12.6,5.75C78.68,44.65,75.26,43.29,72.55,40.62z'
				/>
				<path className='tb0' d='M105.37,20.66h-8.12v-4.21h20.64v4.21h-8.12v23.57h-4.4V20.66z' />
				<path
					className='tb0'
					d='M122.94,40.59c-2.74-2.74-4.1-6.13-4.1-10.11c0-4.02,1.39-7.44,4.21-10.26c2.82-2.82,6.2-4.25,10.19-4.25
		c4.02,0,7.41,1.39,10.23,4.21s4.21,6.2,4.21,10.19c0,3.99-1.39,7.37-4.21,10.15c-2.82,2.78-6.24,4.17-10.34,4.17
		C129.1,44.68,125.68,43.33,122.94,40.59z M140.27,37.58c1.92-1.92,2.9-4.32,2.9-7.18c0-2.9-0.98-5.34-2.9-7.26
		c-1.92-1.92-4.25-2.89-7.03-2.89c-2.74,0-5.11,0.98-7.03,2.93c-1.92,1.92-2.86,4.32-2.86,7.22c0,2.82,0.94,5.23,2.82,7.14
		c1.92,1.92,4.25,2.89,7.07,2.89C136.02,40.44,138.35,39.5,140.27,37.58z'
				/>
				<path
					className='tb0'
					d='M173.21,36.22c0,2.18-0.79,4.06-2.33,5.64c-1.54,1.58-3.68,2.37-6.35,2.37h-11.84V16.45H164
		c2.44,0,4.32,0.68,5.68,2.07c1.39,1.39,2.07,3.01,2.07,4.85c0,2.52-1.5,4.81-3.8,5.68C171.37,29.95,173.21,32.88,173.21,36.22z
		 M156.96,20.4v7.18h6.24c2.59,0,4.14-1.73,4.14-3.72c0-1.92-1.54-3.46-3.99-3.46H156.96z M163.77,40.29c3.05,0,4.93-2.03,4.93-4.4
		c0-2.44-1.77-4.47-5.04-4.47h-6.69v8.87H163.77z'
				/>
				<path
					className='tb0'
					d='M193.29,23.97h3.99v20.26h-3.99v-2.78c-1.84,2.18-4.17,3.27-6.92,3.27c-2.89,0-5.34-1.02-7.26-3.08
		c-1.92-2.07-2.86-4.62-2.86-7.67c0-3.04,0.94-5.53,2.86-7.52c1.92-1.99,4.36-2.97,7.26-2.97c2.74,0,5.08,1.09,6.92,3.31V23.97z
		 M191.63,38.93c1.24-1.32,1.84-2.93,1.84-4.85c0-1.88-0.6-3.5-1.84-4.81s-2.78-1.99-4.7-1.99c-1.92,0-3.5,0.68-4.7,1.99
		s-1.8,2.93-1.8,4.85c0,1.92,0.6,3.54,1.8,4.85s2.78,1.96,4.7,1.96C188.85,40.92,190.39,40.25,191.63,38.93z'
				/>
				<path
					className='tb0'
					d='M200.85,40.47l2.67-2.41c1.24,1.99,3.27,3.08,5.19,3.08c1.96,0,3.35-1.13,3.35-2.52
		c0-0.98-0.56-1.77-1.73-2.33c-0.34-0.19-1.17-0.53-2.44-1.02c-1.24-0.53-2.11-0.9-2.56-1.17c-2.14-1.13-3.23-2.78-3.23-5
		c0-1.69,0.64-3.08,1.88-4.17c1.28-1.09,2.97-1.65,5.04-1.65c2.89,0,5.11,1.05,6.65,3.12l-2.41,2.56c-1.2-1.47-2.67-2.22-4.44-2.22
		c-1.69,0-2.71,0.98-2.71,2.22c0,0.98,0.56,1.73,1.69,2.22l2.07,0.86c1.28,0.53,2.22,0.94,2.86,1.28c2.29,1.2,3.46,2.89,3.46,5.11
		c0,1.77-0.71,3.27-2.11,4.47s-3.23,1.8-5.45,1.8C205.51,44.72,202.54,43.29,200.85,40.47z'
				/>
				<path
					className='tb0'
					d='M239.12,35.7h-15.83c0.6,3.16,2.82,5.3,6.73,5.3c2.29,0,5.08-0.87,6.88-2.18l1.73,3.05
		c-2.07,1.54-5.34,2.82-8.76,2.82c-7.59,0-10.87-5.3-10.87-10.64c0-3.05,0.94-5.56,2.86-7.56c1.92-1.99,4.44-3.01,7.48-3.01
		c2.89,0,5.3,0.9,7.14,2.75c1.84,1.84,2.78,4.32,2.78,7.48C239.27,34.27,239.24,34.95,239.12,35.7z M223.29,32.31h11.8
		c-0.34-3.2-2.71-5.26-5.75-5.26C226.23,27.05,223.9,29.16,223.29,32.31z'
				/>
			</g>
			<g className='tb1'>
				<path
					className='tb4'
					d='M21.1,53.68h-9.68c-1.41,0-2.57-1.16-2.57-2.57V11.56c0-1.41,1.16-2.57,2.57-2.57h39.55
		c1.41,0,2.57,1.16,2.57,2.57v8.66H24.87c-1.04,0-1.98,0.42-2.67,1.11s-1.11,1.63-1.11,2.67V53.68z'
				/>
				<path
					className='tb5'
					d='M36.06,53.68H23.51V23.99c0-0.37,0.15-0.71,0.4-0.96c0.25-0.25,0.59-0.4,0.96-0.4h28.67v12.72h-13.7
		c-1.04,0-1.98,0.42-2.67,1.11c-0.68,0.68-1.11,1.63-1.11,2.67V53.68z'
				/>
				<path
					className='tb6'
					d='M50.97,53.68H38.48V39.13c0-0.37,0.15-0.71,0.4-0.96c0.25-0.25,0.59-0.4,0.96-0.4h13.7v13.34
		C53.54,52.53,52.38,53.68,50.97,53.68z'
				/>
			</g>
		</svg>
	)
}
